import { render } from "./AddressPrinting.vue?vue&type=template&id=131bc453"
import script from "./AddressPrinting.vue?vue&type=script&lang=js"
export * from "./AddressPrinting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__